import { MAMIHELP_URL } from '~/constants/urls';

export const PRIME_PREFIX_API = 'prime';

export const PRIME_PLACEMENT_LOCALSTORAGE = 'primePlacementSelected';
export const PRIME_LOCAL_STORAGE = 'primePackageSelected';

export const URL_PREVIEW_PACKAGE_SUGGESTION = `${MAMIHELP_URL}/post/bagaimana-tampilan-iklan-saya-di-mamiprime-halaman-pencarian-kos`;

export const URL_PREVIEW_PACKAGE_SRP = `${MAMIHELP_URL}/post/bagaimana-tampilan-iklan-saya-di-mamiprime-halaman-hasil-pencarian`;
